import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

function initVideoSlider() {
    const sliders = document.querySelectorAll('.video-swiper');
    
    sliders.forEach(slider => {
        // Initialize Swiper
        const swiper = new Swiper(slider, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            centeredInsufficientSlides: true,
            navigation: {
                prevEl: slider.closest('.video-slider').querySelector('.slider-nav .slider-prev'),
                nextEl: slider.closest('.video-slider').querySelector('.slider-nav .slider-next'),
            },
            breakpoints: {
                900: {
                    slidesPerView: 3
                },
                576: {
                    slidesPerView: 2
                },
            }
        });
    });
};

initVideoSlider();